import React, { useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Modal from "../../../shared/components/Modal";
import history from "../../../history";

export default function ReactTableActions({
  data,
  rows,
  titleAlert,
  setOpenModal,
  setFormData,
  historyUrl = undefined,
  actionsList = [],
  onActivate,
  onInactivate,
  enableActivate,
  enableUpdate,
  enableView = false,
  setIsView,
  enableDocumentarytype,
  loadList,
  isModalRol,
  setIsEditMode,
  consultarRegistro,
}) {
  const [isdelete, setIsdeleted] = useState(false);
  const [isReactive, setIsReactive] = useState(false);

  const handleDelete = async () => {
    setIsdeleted(false);
    loadList();
    onInactivate(data);
  };

  const handleReactivate = async () => {
    setIsReactive(false);
    loadList();
    onActivate(data);
  };

  const handleView = () => {
    if (isModalRol) {
      const dataFormated = { ...data };
      if (
        dataFormated.tipo_documental &&
        typeof dataFormated.tipo_documental === "object"
      ) {
        dataFormated.tipo_documental = Object.keys(dataFormated.tipo_documental)
          .map((k) => parseInt(k, 10))
          .filter((n) => !Number.isNaN(n));
      }
      setFormData(dataFormated);
    } else {
      setFormData(data);
    }
    setIsView(true);
    setOpenModal(true);
    setIsEditMode(true);
    consultarRegistro();
  };

  const handleOpen = () => {
    if (isModalRol) {
      const dataFormated = { ...data };
      if (
        dataFormated.tipo_documental &&
        typeof dataFormated.tipo_documental === "object"
      ) {
        dataFormated.tipo_documental = Object.keys(dataFormated.tipo_documental)
          .map((k) => parseInt(k, 10))
          .filter((n) => !Number.isNaN(n));
      }
      setFormData(dataFormated);
    } else if (
      data.direccion &&
      typeof data.direccion === "object" &&
      !Array.isArray(data.direccion)
    ) {
      // Extraer los atributos de direccion y reemplazar en data
      const { direccion, ...rest } = data;
      const dataWithDireccion = { ...rest, ...direccion };

      setFormData(dataWithDireccion);
    } else {
      setFormData(data);
    }

    setIsEditMode(true);
    setOpenModal(true);
  };

  return (
    <div>
      <td role="cell">
        {actionsList.map(
          (action, idx) =>
            (!action.show || action.show(data)) && (
              <Tooltip title={action.title} key={idx}>
                <IconButton
                  aria-label={action.ariaLabel}
                  style={{ padding: 2 }}
                  onClick={() => action.onClick(data)}
                  disabled={!!action.disabled && action.disabled(data)}
                >
                  {action.icon}
                </IconButton>
              </Tooltip>
            ),
        )}

        {!!enableView && (
          <Tooltip title="Ver">
            <IconButton
              aria-label="view"
              style={{ padding: 2 }}
              onClick={handleView}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )}

        {enableUpdate && (
          <Tooltip title="Actualizar">
            <IconButton
              aria-label="update"
              style={{ padding: 2 }}
              onClick={handleOpen}
            >
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}

        {enableActivate && (
          <>
            <Tooltip title={data.estado === "A" ? "Inactivar" : "Activar"}>
              <div
                role="switch"
                aria-checked={data.estado === "A"}
                style={{
                  display: "inline-block",
                  marginLeft: 5,
                  marginTop: 20,
                }}
              >
                <div
                  onClick={() => {
                    if (data.estado === "A") {
                      setIsdeleted(true);
                    } else {
                      setIsReactive(true);
                    }
                  }}
                  style={{
                    width: 40,
                    height: 22,
                    borderRadius: 11,
                    background: data.estado === "A" ? "#4caf50" : "#f44336",
                    padding: 2,
                    display: "flex",
                    cursor: "pointer",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "transform 0.18s ease",
                      transform:
                        data.estado === "A"
                          ? "translateX(18px)"
                          : "translateX(0)",
                    }}
                  />
                </div>
              </div>
            </Tooltip>
          </>
        )}
      </td>

      <Modal
        color="warning"
        title={`¿Esta seguro que desea inactivar ${titleAlert}?`}
        modal={isdelete}
        onOk={handleDelete}
        toggle={() => setIsdeleted(!isdelete)}
      />
      <Modal
        color="warning"
        title={`¿Se reactivara ${titleAlert}, esta seguro?`}
        modal={isReactive}
        onOk={handleReactivate}
        toggle={() => setIsReactive(!isReactive)}
      />
    </div>
  );
}
